module.exports = __webpack_public_path__ + "media/DROP.1567d97b.mp3";